import PostContext from "configurator-studio-arkitekter-components/dist/common/components/Post/context";

export default PostContext;
